import ApiSignals, { ApiSignalFetchers } from "@/apis/api_signals"
import { computed } from "@preact/signals"
import { createLogger } from "@/utils/logger"

const logger = createLogger("")

async function fetchFinanceChannelList(mode: "1" | "2") {
    // 1 表示充值，2 表示提现
    await ApiSignalFetchers.fetchDataSignalFinanceChannelList({ mode: mode })
}

const channelList = computed(() => {
    return ApiSignals.dataSignalFinanceChannelList.value?.data
})

export { fetchFinanceChannelList, channelList }
